import React from 'react'
import { connect } from 'react-redux'

import Button from '@components/Button'

import { componentSelector } from '../../wordpress/selectors'

import '../styles/Career.scss'

const careerConfigurationSelector = componentSelector('careers')

export const Careers = ({ career }) => {
    const getLink = () =>
        career.buttonAction === 'page'
            ? {
                  href: career.page,
              }
            : {
                  href: career.url,
                  external: true,
              }

    return (
        <div className="career container-fluid">
            <div className="inner-container">
                <Image className="img-container" image={career.image} background />
                <div className="info-container">
                    <h1>{career.title}</h1>
                    <div className="divider">
                        <hr />
                    </div>
                    <div className="text text-large">{career.content}</div>
                    <Button btnStyle="outline-invert" className="font-weight-bold" inline {...getLink()}>
                        {career.buttonLabel}
                    </Button>
                </div>
            </div>
        </div>
    )
}

export const Career = career => (career.enabled ? <Careers career={career} /> : null)

export default connect(careerConfigurationSelector)(Career)
